'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-weight: 600;\n  '], ['\n    font-weight: 600;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: 45px;\n  '], ['\n    font-size: 45px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 14px;\n  '], ['\n    font-size: 14px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _Terms = require('self-service-api/constants/Terms');

var Terms = _interopRequireWildcard(_Terms);

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BillingCaption = _styledComponents2.default.div.withConfig({
  displayName: 'CalculatorPriceDisplayTile__BillingCaption'
})(['font-size:13px;font-weight:600;line-height:20px;text-transform:uppercase;', ';'], _responsiveBreakpoints2.default.tablet(_templateObject));

var MonthlyPriceDisplay = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'CalculatorPriceDisplayTile__MonthlyPriceDisplay'
})(['font-size:38px;font-weight:bold;', ';'], _responsiveBreakpoints2.default.tablet(_templateObject2));

var PriceBreakdownLink = (0, _styledComponents2.default)(_UILink2.default).withConfig({
  displayName: 'CalculatorPriceDisplayTile__PriceBreakdownLink'
})(['color:', ' !important;', ';'], _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject3));

var StyledTermMessage = _styledComponents2.default.div.withConfig({
  displayName: 'CalculatorPriceDisplayTile__StyledTermMessage'
})(['font-size:26px;font-weight:600;display:inline-flex;']);

var StyledPriceDisplay = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'CalculatorPriceDisplayTile__StyledPriceDisplay'
})(['font-size:18px;font-weight:400;']);

var StyledCTAsWrapper = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'CalculatorPriceDisplayTile__StyledCTAsWrapper'
})(['margin-top:25px;margin-bottom:20px;text-align:center;button,a{display:block;width:200px;line-height:24px;}a{padding-top:16px;}']);

var getBreakdownLinkGAClassName = function getBreakdownLinkGAClassName(gaTrackingId) {
  return (0, _publicPageUrls.getGAClassName)(gaTrackingId + '-pricing-breakdown');
};
var CalculatorPriceDisplayTile = function CalculatorPriceDisplayTile(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      activeTerm = _ref.activeTerm,
      gaTrackingId = _ref.gaTrackingId,
      onViewPriceBreakdownClick = _ref.onViewPriceBreakdownClick,
      costToGetStarted = _ref.costToGetStarted,
      monthlyCost = _ref.monthlyCost,
      ctasComponent = _ref.ctasComponent;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        BillingCaption,
        { className: 'm-bottom-5 m-top-5 p-x-8' },
        _react2.default.createElement(_FormattedMessage2.default, {
          message: 'pricingPage.calculator.priceDisplay.billingCaptions.' + activeTerm
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'm-bottom-8' },
        _react2.default.createElement(MonthlyPriceDisplay, {
          currencyCode: activeCurrencyCode,
          price: monthlyCost,
          dataSelenium: 'calculator-monthly-price'
        }),
        _react2.default.createElement(
          StyledTermMessage,
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.perMonth' })
        )
      ),
      _react2.default.createElement(
        BillingCaption,
        { className: 'p-x-12 m-bottom-2' },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.estimatedCostText' })
      ),
      _react2.default.createElement(StyledPriceDisplay, {
        currencyCode: activeCurrencyCode,
        price: costToGetStarted,
        dataSelenium: 'calculator-total-price'
      })
    ),
    _react2.default.createElement(
      StyledCTAsWrapper,
      { direction: 'column', justify: 'center', align: 'center' },
      ctasComponent
    ),
    _react2.default.createElement(
      PriceBreakdownLink,
      {
        onClick: onViewPriceBreakdownClick,
        underline: true,
        className: getBreakdownLinkGAClassName(gaTrackingId)
      },
      _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricingPage.calculator.priceBreakdown.link',
        className: getBreakdownLinkGAClassName(gaTrackingId)
      })
    )
  );
};

CalculatorPriceDisplayTile.propTypes = {
  activeTerm: _react.PropTypes.oneOf(Object.values(Terms || {})).isRequired,
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  onViewPriceBreakdownClick: _react.PropTypes.func.isRequired,
  costToGetStarted: _react.PropTypes.number.isRequired,
  monthlyCost: _react.PropTypes.number.isRequired,
  ctasComponent: _react.PropTypes.node.isRequired,
  gaTrackingId: _react.PropTypes.string.isRequired
};

exports.default = CalculatorPriceDisplayTile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalculatorPriceDisplayTile.js
// module id = 595
// module chunks = 3 4